import enLocale from 'element-ui/lib/locale/lang/en'
export default {
    ...enLocale,
    customer: {
        service_log: "service log",
        service_log_add: "add service log",

        service_log_edit: "edit service log",
        user_name: 'user name',
    },
    tab: {
        sort: 'sort',

        save: 'save',
        cancel: 'cancel',
        //反垃圾配置  SMTP参数
        smtp: 'SMTP param',
        spams: 'Anti safety param',
        virus: 'Anti virus param',
        lagc: 'Logclean param',
        alert: 'Alert param',
        real: 'Real black',
        remote: 'Remote syslog config',
        remote1: 'Offline test config',
        // SMTP参数 页面
        smtp1: 'Client connect count limit',
        smtp2: 'Client connect rate limit',
        smtp3: 'Client message rate limit',
        smtp4: 'Client recipient rate limit',
        smtp5: 'Message Size Limit',
        smtp6: 'max queue lifetime',
        smtp7: 'SMTP error command limit',
        smtp8: 'SMTP maximum of bytes',
        smtp8_title: 'The minimum number of session bytes is 10M',

        smtp9: 'SMTP maximum of messages',
        smtp10: 'SMTP greeting delay(<=30s)',
        smtp11: 'Maximum of recipients',
        smtp12: 'Local network',
        smtp13: 'Friends network',
        smtp14: 'Unknown network',
        // 反垃圾基本参数
        spams1: 'filter action',
        spams2: 'check auto whitelist',
        spams3: 'save rejected spam',
        spams4: 'enbale regex whitelist',
        spams5: 'chek weak password',
        spams6: 'smtp auth ip limit',
        spams7: 'Close collect local',
        spams8: 'Sub audit time',
        spams9: 'Sub audit num',
        spams10: 'Max num of different url on one ip',
        spams11: 'Max link num of check url blacklist',
        spams12: 'Noticy subject',
        spams13: 'Add header key',
        spams14: 'Add header value',
        spams15: 'SMTP Maximum',
        spams16: 'Maximum Idle SMTP',
        spams17: 'Maximum IP_segments',
        spams18: 'MTA base frequency cycle of SMTP(s)',
        spams19: 'The time unit over which client connection rates and other rates are calculated',
        spams20: 'MTA comes with reverse',

        spams21: 'Defer queue interval minimum time(s)',
        spams22: 'Defer queue interval maximum time(s)',
        spams23: 'Defer queue scan period(s)',
        spams24: 'Defer queue scan period(s)',
        spams25: 'Return cycle',
        spams26: 'Maximum queue generation period(d)',
        spams27: 'Name of return account',
        spams28: 'Strategic protection level',
        spams29: 'DMARC filter action',
        spams30: 'Anonymous email blocking',
        spams31: 'Whether to enable subject auditing',



        spams2001: 'remember mail communication and add into whitelist automatic',
        spams3001: 'spam rejected in the content phase will be kept in isolation with a single copy',
        spams4001: 'you can set subject or content white regex,if match ,pass this ma',
        spams5001: 'The password of user auth will check with weak if is on',
        spams6001: 'Unauthorized IP addresses will not be able to send mail by SMTP authentication if is on',
        spams7001: 'If closed,will not collect digest of local emai',
        spams8001: 'Set the audit time of same subject,can not lower than 10 minute',
        spams9001: 'Set the audit num of same subject,can not lower than 10',
        spams10001: 'Different url on one ip,if num of url reach set num,then rejected,min set by 4',
        spams11001: 'When the links of one email less than or equal to set num,then check url blacklist,min set by 2',
        spams12001: 'Set the subject of noticy mail,keep the original subject if not set',
        // 反病毒基本参数
        virus1: 'Virus scan action',
        virus2: 'Virus scan timeout',
        virus3: 'Virus scan max size',
        virus4: 'scanner anti-virus port',
        virus5: 'scanner anti-virus host',
        virus6: 'check virus',
        virus7: 'ruixing scanner',
        virus8: 'save rejected virus',
        virus9: 'Built-in antivirus',
        virus10: 'It will not scan the email with virus if check is off',
        virus11: 'ruixing scanner anti-virus',
        virus12: 'When enabled,a single copy of the rejected spam is kept in quarantine',
        virus13: 'check 360 virus',
        virus14: '360 scanner anti-virus',
        virus15: '360 antivirus binary program',
        virus16: '360 antivirus middleware',
        virus17: 'Clean virus',
        virus18: 'Clean virus when saving spam',
        virus19: 'Redirect the virus file',
        // 日志清理设置
        logc1: 'Mailllog save days',
        logc2: 'Filter log save days',
        logc3: 'Auth log save days',
        logc4: 'Queue save days',
        logc5: 'Realtime log save days',
        logc6: 'Spam save days',
        logc7: 'Archive save days',
        logc8: 'Pagesize default',
        // 警报设置
        alert1: 'Alert Sender',
        alert2: 'Alert Recipient',
        alert3: 'Service Prosess',
        alert4: 'abnormal Sender',
        alert5: 'Version Update',
        alert6: 'License Expire',
        alert7: 'Disk Partition',
        alert8: 'IP Authfail',
        alert9: 'IP Reject',
        alert10: 'Cur Queue',
        // 实时黑名单

        alert11: 'Domain addr',
        alert15: 'TLS alarm',
        alert12: 'Code IP',
        alert13: 'Add Rral Black',
        alert16: 'Edit Rral Black',
        alert14: 'Using other anti spam organizations to query black lists in real time',
        // 远程syslog配置
        remote_a1: 'Enable filterlog syslog',
        remote_a2: 'IF enable filterlog syslog,the filter log will syslog to remote host',
        remote_a3: 'Syslog remote host',
        remote_a4: 'Default port is 514,if set other port,set such as 1.1.1.1:514,use comma to split if set two or more',
        remote_a5: 'Add syslog header keys',
        remote_a6: 'One header key each line',
        remote_a7: 'Syslog contains time, mid, ip, from, to, helo, subject, stage, type,  can also add such as Message-ID Return-Path and so on',
        // 离线测试配置
        remote_b1: 'Enable offline test',
        remote_b2: 'Be sure the trust ip of mta,relay domain and route has config begin offline test',
        remote_b3: 'Test sender address',
        remote_b4: 'Some policy will not check with the set of sender when offline test',
    }
}